<template>
    <li class="list notranslate">
        <div class="list_content">
            <p>
                <span
                    v-if="scoreDisplay"
                    class="live-score"
                    data-testid="bet-builder-combination-leg-score"
                >{{ scoreDisplay }}</span>
                <span>{{ market.marketType.name }}</span>
                <span>|</span>
                <strong>{{ fullName }}</strong>
                <span
                    v-if="point"
                    class="oddsPoint"
                >{{ point }}</span>
            </p>
        </div>
    </li>
</template>

<script lang="ts" setup>
    import { computed, toRefs } from 'vue';
    import { formatMarketGroupScore, getBetBuilderTicketGroupScore } from '@/components/betBuilder/betBuilderOddsDisplay';
    import { useBetBuilderSelection } from '@/components/betBuilder/useBetBuilderSelection';
    import type { IRecommendationEvent } from '@/interface/IBetBuilderRecommendation';
    import type { IBetBuilderMarket, IBetBuilderSelection } from '@/interface/betBuilder';

    const props = defineProps<{
        market: IBetBuilderMarket;
        selection: IBetBuilderSelection;
        event: IRecommendationEvent | null;
    }>();

    const { market, selection, event } = toRefs(props);
    const { fullName, point } = useBetBuilderSelection(market, selection);

    const scoreDisplay = computed(() => formatMarketGroupScore(getBetBuilderTicketGroupScore(
        event.value?.isLive ?? false,
        market.value.marketType.id,
        event.value?.eventResults ?? [],
    )));
</script>

<style lang="scss" scoped>
@import "@/scss/components/quickCombinationTicket";

</style>
